import moment from "moment";
import { IDateFormatService } from "@/services/Date/dateFormat.types";

export class DateFormatService implements IDateFormatService {
  dateCommonFormat(date: any, format: string) {
    let givenDate = moment(date).format(format);
    // const [day, month, year] = givenDate.split("-");
    // let changedDate = `${day}/${month}/${year}`;
    return givenDate;
  }
}
